import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("smartqr_theme") || "dark";
  });

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    localStorage.setItem("smartqr_theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);

export function useChartTheme() {
  const { theme } = useTheme();
  return theme === "dark"
    ? {
        tooltipStyle: {
          background: "#18181b",
          border: "1px solid #27272a",
          borderRadius: "8px",
          color: "#f4f4f5",
        },
        gridColor: "#27272a",
        tickColor: "#a1a1aa",
      }
    : {
        tooltipStyle: {
          background: "#ffffff",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          color: "#09090b",
        },
        gridColor: "#e5e7eb",
        tickColor: "#6b7280",
      };
}
